import SectionOrganizerConstants from './SectionOrganizerConstants';


export const addFieldToSectionOrganizer = (fieldId, sectionIndex = null) => (
  (dispatch) => {
    dispatch({
      type: SectionOrganizerConstants.SELF_SERVE_BUILDER_SECTION_ORGANIZER_FIELD_ADD,
      fieldId,
      sectionIndex,
    });
  }
);


export const removeFieldFromSectionOrganizer = (fieldId, removeEmptySection = false) => (
  (dispatch) => {
    dispatch({
      type: SectionOrganizerConstants.SELF_SERVE_BUILDER_SECTION_ORGANIZER_FIELD_REMOVE,
      fieldId,
      removeEmptySection,
    });
  }
);

export const reorderSectionFromSectionOrganizer = (sourceIndex, destinationIndex) => (
  (dispatch) => {
    dispatch({
      type: SectionOrganizerConstants.SELF_SERVE_BUILDER_SECTION_ORGANIZER_SECTION_MOVE,
      sourceIndex,
      destinationIndex,
    });
  }
);

export const moveFieldIdInSectionOrganizer = (
  sourceSectionId,
  sourceIndex,
  destinationSectionId,
  destinationIndex,
) => (
  (dispatch) => {
    dispatch({
      type: SectionOrganizerConstants.SELF_SERVE_BUILDER_SECTION_ORGANIZER_FIELD_MOVE,
      sourceSectionId,
      sourceIndex,
      destinationSectionId,
      destinationIndex,
    });
  }
);

export const splitSectionInSectionOrganizer = (
  newSectionName,
  sectionIndex,
  fieldIndex,
) => (
  (dispatch) => {
    dispatch({
      type: SectionOrganizerConstants.SELF_SERVE_BUILDER_SECTION_ORGANIZER_SECTION_SPLIT,
      newSectionName,
      sectionIndex,
      fieldIndex,
    });
  }
);

export const addSectionToSectionOrganizer = (sectionName, isMultiField = true, isNameEditable = true, isDroppable = true, isDraggable = false) => (
  (dispatch) => {
    dispatch({
      type: SectionOrganizerConstants.SELF_SERVE_BUILDER_SECTION_ORGANIZER_SECTION_ADD,
      isDroppable,
      isDraggable,
      isMultiField,
      isNameEditable,
      sectionName,
    });
  }
);

export const removeSectionFromSectionOrganizer = sectionIndex => (
  (dispatch) => {
    dispatch({
      type: SectionOrganizerConstants.SELF_SERVE_BUILDER_SECTION_ORGANIZER_SECTION_REMOVE,
      sectionIndex,
    });
  }
);

export const renameSectionFromSectionOrganizer = (sectionName, sectionIndex) => (
  (dispatch) => {
    dispatch({
      type: SectionOrganizerConstants.SELF_SERVE_BUILDER_SECTION_ORGANIZER_SECTION_RENAME,
      sectionName,
      sectionIndex,
    });
  }
);



// WEBPACK FOOTER //
// ./src-react/SelfServePostBuilderSidePanel/SectionOrganizer/SectionOrganizerActions.jsx